// extracted by mini-css-extract-plugin
export default {"CandidateResumeProjectExpectations__description":"_PhY8"};